import React from 'react';
import Content from './Component/Content';
import Cookie from 'react-cookies';
import BreadCrumb from './Component/BreadCrumb';
import Helper from './Component/Helper';
import NumberFormat from 'react-number-format';
import ReactDOMServer from 'react-dom/server';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
class App extends React.Component {
  constructor(props){
    super();
    let cart = [];
    if(Storage)
    {
        cart = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')):[];
    }
    this.state = {
      accountLogin:Cookie.load('pbuniq'),
      productsFull:[],
      products:[],
      isLoaded:false,
      error:null,
      cart:cart,
      menuCates:null,
      cate: null,
      event:null,
      config: window.HEADER.config
    };
  }
  componentDidMount() {
    let lastSegmentUrl = Helper.getLastSegmentUrl(),
    eventId = lastSegmentUrl === 'deal-giam-soc' || lastSegmentUrl==='hot-deal' ? 'best_deal' : (lastSegmentUrl === 'goi-y-cho-ban'?'suggestion':'daily_deal'),
    eventName = eventId === 'best_deal' ? 'Deal giảm sốc' : (eventId==='suggestion'?'Gợi ý cho bạn':'Deal hot hàng ngày')
    Promise.all([
      fetch('https://pibook.vn/post/getAjaxPostEvent',{
        method:'POST',
        body: JSON.stringify({event:eventId})
      }),
      fetch('https://pibook.vn/menu/getEventCates',{
        method:'POST',
        body: JSON.stringify({event:eventId})
      })
    ])
    .then(([res1, res2])=>Promise.all([res1.json(), res2.json()]))
    .then(([res1, res2])=>{
        let productsFull = res1 && typeof res1.err ==='undefined'?res1:null;
        this.setState({
          productsFull:productsFull,
          products: productsFull ? productsFull.items:null,
          menuCates: res2 && typeof res2.err ==='undefined' ? res2 : null,
          isLoaded:true,
          event: {
            id:eventId,
            name: eventName,
            link: `/${lastSegmentUrl}`
          }
        })        
    },(error)=>{console.log(error)}
    )
  }
  addToCart = (cart)=>{
    const $ = window.jQuery;
    if(!cart) return;
    localStorage.setItem('cart', JSON.stringify(cart));
    
    $('body').append('<div class="loading-img"></div>');
    setTimeout(() => {
      let notify =()=>toast.success('Thêm thành công',{
        position:'top-right',
        autoClose:1200,
        hideProgressBar:false,
        closeOnClick:true,
        pauseOnHover:true,
        draggable:true,
        progress:undefined
      });
      notify();
      this.setState({cart:cart});
    }, 200);
  }
  componentDidUpdate(){
    const $ = window.jQuery;
    $('div.loading-img').remove();
    $('.filter-toggle.sub-page-nav').hide();
    let carts = localStorage.getItem('cart');
    carts = JSON.parse(carts)??[];
    if(carts.length)
    {
      $("#Header_cart span.sticky-number").length?$("#Header_cart span.sticky-number").text(carts.length):
      $("#Header_cart").append(`<span class="rounded-circle d-block position-absolute sticky-number">${carts.length}</span>`);
      
      $('#Header_cart_mobile span.sticky-number').length?$('#Header_cart_mobile span.sticky-number').text(carts.length): 
      $('#Header_cart_mobile').append(`<span class="rounded-circle d-block position-absolute sticky-number">${carts.length}</span>`);

      let cartView = carts.map((cartItem, index)=>{
        return (
          <li className="list-group-item d-flex justify-content-start py-2" key={index}>
            <a href={cartItem.link} title={cartItem.title} className="product-image">
              <img src={cartItem.image} width={60} alt={cartItem.title} />
            </a>
            <div className="product-details">
              <p><a href={cartItem.link}>{Helper.wordLimiter(cartItem.title, 10)}</a></p>
              <strong className="text-medium">{cartItem.cnt}</strong> x  
              <span className="text-medium text-danger">
              <NumberFormat value={cartItem.price} thousandSeparator="." decimalSeparator=","
              displayType={"text"} renderText={(value)=>`${value} đ`}/>
              </span>
              <a href="/gio-hang" className="text-left viewmore py-2">Chi tiết</a>
            </div>
          </li>
        );
      })

      let cartList = 
          <ul className="text-left list-group list-group-flush">
              {cartView}
          </ul>;
      const cartListHtml = ReactDOMServer.renderToString(cartList);
      
      $('#Header_cart_list').removeClass('d-none').html(cartListHtml);
    }
  }
  handleChangeCate=(item)=>{
    let {productsFull} = this.state,
    products = null;
    const $ = window.jQuery;
    if(item !== 'all')
    {
      fetch('https://pibook.vn/category/getAjaxNavCategory', {
        method:'POST',
        body: JSON.stringify({id:item.category_id})
      }).then(res=>res.json())
      .then(res=>{
        if(res && typeof res.err ==='undefined'){
          let childs = res.child.length ? res.child.map((c)=>c.id):[];
          childs.push(res.id);
          childs = [... new Set(childs)];
          products = productsFull.items.filter((item)=>childs.includes(item.meta.category));
          
          $('body').append('<div class="loading-img"></div>');
          setTimeout(() => {
            this.setState({
              cate: item && item !== 'all' ? item : null,
              products:products
            })
          }, 200);
        }
        
      })
    }
    else{
      $('body').append('<div class="loading-img"></div>');
        setTimeout(() => {
          this.setState({
            cate: null,
            products:productsFull.items
          })
        }, 200);
    }
    
  }
  render(){
    let {isLoaded, cart, error, products, config, menuCates, event, cate} = this.state;
    if(!isLoaded)
    {
      return <div className="loading"></div>
    }
    else
    {
        let configDeal = config.find((item)=>item.config_name ===event.id);
        
        return error ? <div className="text-center my-4 text-uppercase">{error}</div> :(
        <div className="app">
            <BreadCrumb cate={cate} event={event} />
            <Content cart={cart} addToCart={this.addToCart} products={products} cate={cate} handleChangeCate={this.handleChangeCate}
            menuCates={menuCates} configDeal={configDeal} event={event} />
            <ToastContainer />
        </div>
      );
    }
  }
}

export default App;
